import { createMuiTheme } from "@material-ui/core/styles";

export const theme =
  // responsiveFontSizes(
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px", // theme.spacing(0),
        },
      },
    },
  });
// );
